// ClientMenuV2 — UI padrão global. Menu do cliente no topo da página
// pública: adiciona atalho "Meu Perfil" (hoje só existia "Meus Agendamentos"
// e "Sair"), com alvos de toque >= 44px. Não altera nenhuma lógica de auth —
// só apresenta as mesmas ações (+ 1 nova rota já existente) de forma mais clara.
import React from 'react';
import { Box, Avatar, Typography, Menu, MenuItem, Divider } from '@mui/material';
import { ExpandMore, EventNote, Person, Logout } from '@mui/icons-material';

export function ClientMenuV2({
  custUser, stickyHeader, accentColor, textColor, hoverBg, slug,
}: {
  custUser: any;
  stickyHeader: boolean;
  accentColor: string;
  textColor: string;
  hoverBg: string;
  // Slug da empresa cujo página pública está aberta AGORA. HOTFIX: precisa
  // ser transportado explicitamente para /meus-agendamentos — sem isso, a
  // tela usa o último slug salvo no localStorage (de uma visita anterior a
  // OUTRA empresa), mostrando cor/dados de um estabelecimento errado.
  slug: string;
}) {
  const [anchor, setAnchor] = React.useState<null | HTMLElement>(null);

  const goTo = (path: string) => {
    setAnchor(null);
    const sep = path.includes('?') ? '&' : '?';
    window.location.href = window.location.origin + path + sep + 's=' + encodeURIComponent(slug);
  };

  return (
    <>
      <Box
        onClick={e => setAnchor(e.currentTarget)}
        sx={{
          display: 'flex', alignItems: 'center', gap: 0.75, cursor: 'pointer',
          borderRadius: 2.5, pl: 0.5, pr: 1.25,
          minHeight: 44, // alvo de toque
          bgcolor: stickyHeader ? 'transparent' : 'rgba(0,0,0,0.35)',
          '&:hover': { bgcolor: stickyHeader ? hoverBg : 'rgba(0,0,0,0.5)' },
        }}
      >
        <Avatar src={custUser.photo_url || undefined} sx={{ width: 34, height: 34, bgcolor: accentColor, fontSize: 14, fontWeight: 700 }}>
          {custUser.name?.[0]}
        </Avatar>
        <Typography noWrap sx={{ fontSize: 12.5, fontWeight: 600, color: textColor, maxWidth: 72 }}>
          {custUser.name?.split(' ')[0]}
        </Typography>
        <ExpandMore sx={{ fontSize: 15, color: textColor, opacity: 0.6 }} />
      </Box>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: { borderRadius: 2.5, mt: 0.5, minWidth: 200, boxShadow: '0 8px 32px rgba(0,0,0,0.14)' } } }}
      >
        <MenuItem onClick={() => goTo('/meus-agendamentos')} sx={{ minHeight: 44, gap: 1 }}>
          <EventNote sx={{ fontSize: 18, color: '#555' }} />
          <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>Meus agendamentos</Typography>
        </MenuItem>
        <MenuItem onClick={() => goTo('/meus-agendamentos?tab=profile')} sx={{ minHeight: 44, gap: 1 }}>
          <Person sx={{ fontSize: 18, color: '#555' }} />
          <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>Meu perfil</Typography>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => { setAnchor(null); localStorage.removeItem('cust_token'); localStorage.removeItem('cust_user'); window.location.reload(); }}
          sx={{ minHeight: 44, gap: 1 }}
        >
          <Logout sx={{ fontSize: 18, color: '#e53935' }} />
          <Typography sx={{ fontSize: 13.5, color: 'error.main', fontWeight: 500 }}>Sair</Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
